module.exports = __webpack_public_path__ + "img/216.c6770733.png";